import { render, staticRenderFns } from "./SetPayPassword.vue?vue&type=template&id=16553a87&scoped=true"
import script from "./SetPayPassword.vue?vue&type=script&lang=js"
export * from "./SetPayPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPayPassword.vue?vue&type=style&index=0&id=16553a87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16553a87",
  null
  
)

export default component.exports